import useConfig from 'common/hooks/useConfig';

import { useContracts } from '@domains/Organization/Admin/Contracts';
import { STATUS_ACTIVE, STATUS_EXPIRED } from '@domains/Organization/contracts-service';

const CONF_IS_USER_CREDIT_EVENT = 'is_user_credit_event';

export const useEventExpiryDate = event => {
  const config = useConfig();
  const { dataSource: contracts, hasActiveContract } = useContracts();
  const activeContract = hasActiveContract
    ? contracts?.find(contract => contract.status === STATUS_ACTIVE)
    : null;
  const expiredContracts = contracts?.filter(contract => contract.status === STATUS_EXPIRED);
  const isUserCreditEvent = config.isConfigEnabled(CONF_IS_USER_CREDIT_EVENT);

  const getExpiryDate = () => {
    // Access for PCL events expires at the end of contract instead of event end-date
    if (!isUserCreditEvent) {
      return event.endDate;
    }
    if (activeContract?.endDate) {
      return activeContract.endDate;
    }
    if (expiredContracts.length) {
      return expiredContracts[0].endDate;
    }
    return event.endDate;
  };

  return { getExpiryDate };
};
